var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_5501)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#0EB3A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0475 10.9955C16.6216 9.64246 18.9565 9.67186 20.4961 11.0641L22.0104 12.4336C23.7276 13.9865 23.8282 16.6491 22.2332 18.3272L20.4223 20.2325L21.2545 21.0735C21.3633 21.1835 21.5414 21.182 21.6482 21.0702L24.2274 18.3724C24.9611 17.605 26.178 17.5776 26.9455 18.3113C27.713 19.045 27.7403 20.262 27.0066 21.0294L24.4275 23.7272C22.8242 25.4042 20.153 25.4271 18.5212 23.7778L17.7722 23.0207L17.1223 23.7045C15.5143 25.3962 12.8235 25.4156 11.1914 23.7472L8.54823 21.0453C7.80575 20.2863 7.81912 19.0692 8.5781 18.3267C9.33708 17.5842 10.5543 17.5976 11.2967 18.3565L13.9399 21.0584C14.0487 21.1697 14.2281 21.1684 14.3353 21.0556L15.0666 20.2862L13.1982 18.3977C11.5182 16.6996 11.6298 13.9332 13.4413 12.3761L15.0475 10.9955ZM17.7168 17.4979L19.4463 15.6783C19.5526 15.5664 19.5459 15.3889 19.4314 15.2854L17.9171 13.9159C17.8144 13.8231 17.6588 13.8211 17.5538 13.9113L15.9477 15.292C15.8269 15.3958 15.8195 15.5802 15.9315 15.6934L17.7168 17.4979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_5501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartVault);
export default __webpack_public_path__ + "static/media/smart-vault.3883a5830a479d35bc9a5f0f4237bb80.svg";
export { ForwardRef as ReactComponent };